
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    /**
 * Infinite Ajax Scroll v3.1.0
 * Turn your existing pagination into infinite scrolling pages with ease
 *
 * Commercial use requires one-time purchase of a commercial license
 * https://infiniteajaxscroll.com/docs/license.html
 *
 * Copyright 2014-2023 Webcreate (Jeroen Fiege)
 * https://infiniteajaxscroll.com
 */ /*! @license Tealight v0.3.6

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.

*/ /*! @license is-dom-node v1.0.4

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.

*/ function $7357500e77c6d40d$var$isDomNode(x) {
    return typeof window.Node === 'object' ? x instanceof window.Node : x !== null && typeof x === 'object' && typeof x.nodeType === 'number' && typeof x.nodeName === 'string';
}
var $7357500e77c6d40d$export$2e2bcd8739ae039 = $7357500e77c6d40d$var$isDomNode;


/*! @license is-dom-node-list v1.2.1

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.

*/ 
function $84d0ffd73abe9d48$var$isDomNodeList(x) {
    var prototypeToString = Object.prototype.toString.call(x);
    var regex = /^\[object (HTMLCollection|NodeList|Object)\]$/;
    return typeof window.NodeList === 'object' ? x instanceof window.NodeList : x !== null && typeof x === 'object' && typeof x.length === 'number' && regex.test(prototypeToString) && (x.length === 0 || (0, $7357500e77c6d40d$export$2e2bcd8739ae039)(x[0]));
}
var $84d0ffd73abe9d48$export$2e2bcd8739ae039 = $84d0ffd73abe9d48$var$isDomNodeList;


function $0762156f26e68f1c$var$tealight(target, context) {
    if (context === void 0) context = document;
    if (target instanceof Array) return target.filter((0, $7357500e77c6d40d$export$2e2bcd8739ae039));
    if ((0, $7357500e77c6d40d$export$2e2bcd8739ae039)(target)) return [
        target
    ];
    if ((0, $84d0ffd73abe9d48$export$2e2bcd8739ae039)(target)) return Array.prototype.slice.call(target);
    if (typeof target === "string") try {
        var query = context.querySelectorAll(target);
        return Array.prototype.slice.call(query);
    } catch (err) {
        return [];
    }
    return [];
}
var $0762156f26e68f1c$export$2e2bcd8739ae039 = $0762156f26e68f1c$var$tealight;


var $16d474a0815e976d$exports = {};
'use strict';
var $16d474a0815e976d$var$hasOwn = Object.prototype.hasOwnProperty;
var $16d474a0815e976d$var$toStr = Object.prototype.toString;
var $16d474a0815e976d$var$defineProperty = Object.defineProperty;
var $16d474a0815e976d$var$gOPD = Object.getOwnPropertyDescriptor;
var $16d474a0815e976d$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $16d474a0815e976d$var$toStr.call(arr) === '[object Array]';
};
var $16d474a0815e976d$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $16d474a0815e976d$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $16d474a0815e976d$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $16d474a0815e976d$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $16d474a0815e976d$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $16d474a0815e976d$var$setProperty = function setProperty(target, options) {
    if ($16d474a0815e976d$var$defineProperty && options.name === '__proto__') $16d474a0815e976d$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $16d474a0815e976d$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$16d474a0815e976d$var$hasOwn.call(obj, name)) return void 0;
        else if ($16d474a0815e976d$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $16d474a0815e976d$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$16d474a0815e976d$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $16d474a0815e976d$var$getProperty(target, name);
            copy = $16d474a0815e976d$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($16d474a0815e976d$var$isPlainObject(copy) || (copyIsArray = $16d474a0815e976d$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $16d474a0815e976d$var$isArray(src) ? src : [];
                    } else clone = src && $16d474a0815e976d$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $16d474a0815e976d$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $16d474a0815e976d$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


var $ac43bb23aa0a60e2$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $ac43bb23aa0a60e2$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $ac43bb23aa0a60e2$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $ac43bb23aa0a60e2$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $ac43bb23aa0a60e2$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $ac43bb23aa0a60e2$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ac43bb23aa0a60e2$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ac43bb23aa0a60e2$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $ac43bb23aa0a60e2$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $ac43bb23aa0a60e2$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $ac43bb23aa0a60e2$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ac43bb23aa0a60e2$var$root = $ac43bb23aa0a60e2$var$freeGlobal || $ac43bb23aa0a60e2$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $ac43bb23aa0a60e2$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ac43bb23aa0a60e2$var$objectToString = $ac43bb23aa0a60e2$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ac43bb23aa0a60e2$var$nativeMax = Math.max, $ac43bb23aa0a60e2$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $ac43bb23aa0a60e2$var$now = function() {
    return $ac43bb23aa0a60e2$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ac43bb23aa0a60e2$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($ac43bb23aa0a60e2$var$FUNC_ERROR_TEXT);
    wait = $ac43bb23aa0a60e2$var$toNumber(wait) || 0;
    if ($ac43bb23aa0a60e2$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $ac43bb23aa0a60e2$var$nativeMax($ac43bb23aa0a60e2$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $ac43bb23aa0a60e2$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $ac43bb23aa0a60e2$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($ac43bb23aa0a60e2$var$now());
    }
    function debounced() {
        var time = $ac43bb23aa0a60e2$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $ac43bb23aa0a60e2$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($ac43bb23aa0a60e2$var$FUNC_ERROR_TEXT);
    if ($ac43bb23aa0a60e2$var$isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $ac43bb23aa0a60e2$var$debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ac43bb23aa0a60e2$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ac43bb23aa0a60e2$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ac43bb23aa0a60e2$var$isSymbol(value) {
    return typeof value == 'symbol' || $ac43bb23aa0a60e2$var$isObjectLike(value) && $ac43bb23aa0a60e2$var$objectToString.call(value) == $ac43bb23aa0a60e2$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ac43bb23aa0a60e2$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($ac43bb23aa0a60e2$var$isSymbol(value)) return $ac43bb23aa0a60e2$var$NAN;
    if ($ac43bb23aa0a60e2$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $ac43bb23aa0a60e2$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($ac43bb23aa0a60e2$var$reTrim, '');
    var isBinary = $ac43bb23aa0a60e2$var$reIsBinary.test(value);
    return isBinary || $ac43bb23aa0a60e2$var$reIsOctal.test(value) ? $ac43bb23aa0a60e2$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ac43bb23aa0a60e2$var$reIsBadHex.test(value) ? $ac43bb23aa0a60e2$var$NAN : +value;
}
$ac43bb23aa0a60e2$exports = $ac43bb23aa0a60e2$var$throttle;


var $bb3d51bfa22856f3$exports = {};
function $bb3d51bfa22856f3$var$E() {
// Keep this empty so it's easier to inherit from
// (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}
$bb3d51bfa22856f3$var$E.prototype = {
    on: function(name, callback, ctx) {
        var e = this.e || (this.e = {});
        (e[name] || (e[name] = [])).push({
            fn: callback,
            ctx: ctx
        });
        return this;
    },
    once: function(name, callback, ctx) {
        var self = this;
        function listener() {
            self.off(name, listener);
            callback.apply(ctx, arguments);
        }
        listener._ = callback;
        return this.on(name, listener, ctx);
    },
    emit: function(name) {
        var data = [].slice.call(arguments, 1);
        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
        var i = 0;
        var len = evtArr.length;
        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
        return this;
    },
    off: function(name, callback) {
        var e = this.e || (this.e = {});
        var evts = e[name];
        var liveEvents = [];
        if (evts && callback) {
            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
        }
        // Remove event from queue to prevent memory leak
        // Suggested by https://github.com/lazd
        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
        liveEvents.length ? e[name] = liveEvents : delete e[name];
        return this;
    }
};
$bb3d51bfa22856f3$exports = $bb3d51bfa22856f3$var$E;
$bb3d51bfa22856f3$exports.TinyEmitter = $bb3d51bfa22856f3$var$E;


var $6c18613b3e53070e$var$defaults$3 = {
    item: undefined,
    next: undefined,
    prev: undefined,
    pagination: undefined,
    responseType: 'document',
    bind: true,
    scrollContainer: window,
    spinner: false,
    logger: true,
    loadOnScroll: true,
    negativeMargin: 0,
    trigger: false,
    prefill: true
};
/* eslint no-console: "off" */ var $6c18613b3e53070e$var$Assert = {
    singleElement: function singleElement(elementOrSelector, property) {
        var $element = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(elementOrSelector);
        if ($element.length > 1) throw new Error("Expected single element for \"" + property + "\"");
        if ($element.length === 0) throw new Error("Element \"" + elementOrSelector + "\" not found for \"" + property + "\"");
    },
    anyElement: function anyElement(elementOrSelector, property) {
        var $element = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(elementOrSelector);
        if ($element.length === 0) throw new Error("Element \"" + elementOrSelector + "\" not found for \"" + property + "\"");
    },
    warn: function warn(fn) {
        var args = [], len = arguments.length - 1;
        while(len-- > 0)args[len] = arguments[len + 1];
        try {
            fn.apply(void 0, args);
        } catch (e) {
            if (console && console.warn) console.warn(e.message);
        }
    }
};
function $6c18613b3e53070e$var$getScrollPosition(el) {
    if (el !== window) return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return {
        x: supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
        y: supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
    };
}
function $6c18613b3e53070e$var$getRootRect(el) {
    var rootRect;
    if (el !== window) rootRect = el.getBoundingClientRect();
    else {
        // Use <html>/<body> instead of window since scroll bars affect size.
        var html = document.documentElement;
        var body = document.body;
        rootRect = {
            top: 0,
            left: 0,
            right: html.clientWidth || body.clientWidth,
            width: html.clientWidth || body.clientWidth,
            bottom: html.clientHeight || body.clientHeight,
            height: html.clientHeight || body.clientHeight
        };
    }
    return rootRect;
}
function $6c18613b3e53070e$var$getDistanceToFold(sentinel, scrollContainerScrollPosition, scrollContainerRootRect) {
    var rootRect = scrollContainerRootRect;
    // this means the container the doesn't have any items yet - it's empty
    if (!sentinel) return rootRect.height * -1;
    var scrollYTop = scrollContainerScrollPosition.y;
    var boundingRect = sentinel.getBoundingClientRect();
    var scrollYBottom = scrollYTop + rootRect.height;
    var bottom = scrollYTop + boundingRect.bottom - rootRect.top;
    return Math.trunc(bottom - scrollYBottom);
}
var $6c18613b3e53070e$var$APPEND = 'append';
var $6c18613b3e53070e$var$APPENDED = 'appended';
var $6c18613b3e53070e$var$PREPEND = 'prepend';
var $6c18613b3e53070e$var$PREPENDED = 'prepended';
var $6c18613b3e53070e$var$BINDED = 'binded';
var $6c18613b3e53070e$var$UNBINDED = 'unbinded';
var $6c18613b3e53070e$var$HIT = 'hit';
var $6c18613b3e53070e$var$TOP = 'top';
var $6c18613b3e53070e$var$LOAD = 'load';
var $6c18613b3e53070e$var$LOADED = 'loaded';
var $6c18613b3e53070e$var$ERROR = 'error';
var $6c18613b3e53070e$var$FIRST = 'first';
var $6c18613b3e53070e$var$LAST = 'last';
var $6c18613b3e53070e$var$NEXT = 'next';
var $6c18613b3e53070e$var$NEXTED = 'nexted';
var $6c18613b3e53070e$var$PREV = 'prev';
var $6c18613b3e53070e$var$PREVED = 'preved';
var $6c18613b3e53070e$var$READY = 'ready';
var $6c18613b3e53070e$var$SCROLLED = 'scrolled';
var $6c18613b3e53070e$var$RESIZED = 'resized';
var $6c18613b3e53070e$var$PAGE = 'page';
var $6c18613b3e53070e$var$PREFILL = 'prefill';
var $6c18613b3e53070e$var$PREFILLED = 'prefilled';
var $6c18613b3e53070e$var$events = {
    APPEND: $6c18613b3e53070e$var$APPEND,
    APPENDED: $6c18613b3e53070e$var$APPENDED,
    PREPEND: $6c18613b3e53070e$var$PREPEND,
    PREPENDED: $6c18613b3e53070e$var$PREPENDED,
    BINDED: $6c18613b3e53070e$var$BINDED,
    UNBINDED: $6c18613b3e53070e$var$UNBINDED,
    HIT: $6c18613b3e53070e$var$HIT,
    TOP: $6c18613b3e53070e$var$TOP,
    LOAD: $6c18613b3e53070e$var$LOAD,
    LOADED: $6c18613b3e53070e$var$LOADED,
    ERROR: $6c18613b3e53070e$var$ERROR,
    FIRST: $6c18613b3e53070e$var$FIRST,
    LAST: $6c18613b3e53070e$var$LAST,
    NEXT: $6c18613b3e53070e$var$NEXT,
    NEXTED: $6c18613b3e53070e$var$NEXTED,
    PREV: $6c18613b3e53070e$var$PREV,
    PREVED: $6c18613b3e53070e$var$PREVED,
    READY: $6c18613b3e53070e$var$READY,
    SCROLLED: $6c18613b3e53070e$var$SCROLLED,
    RESIZED: $6c18613b3e53070e$var$RESIZED,
    PAGE: $6c18613b3e53070e$var$PAGE,
    PREFILL: $6c18613b3e53070e$var$PREFILL,
    PREFILLED: $6c18613b3e53070e$var$PREFILLED
};
var $6c18613b3e53070e$var$defaultLastScroll = {
    y: 0,
    x: 0,
    deltaY: 0,
    deltaX: 0
};
function $6c18613b3e53070e$var$calculateScroll(scrollContainer, lastScroll) {
    var scroll = $6c18613b3e53070e$var$getScrollPosition(scrollContainer);
    scroll.deltaY = scroll.y - (lastScroll ? lastScroll.y : scroll.y);
    scroll.deltaX = scroll.x - (lastScroll ? lastScroll.x : scroll.x);
    return scroll;
}
function $6c18613b3e53070e$var$scrollHandler() {
    var ias = this;
    var lastScroll = ias._lastScroll || $6c18613b3e53070e$var$defaultLastScroll;
    var scroll = ias._lastScroll = $6c18613b3e53070e$var$calculateScroll(ias.scrollContainer, lastScroll);
    this.emitter.emit($6c18613b3e53070e$var$SCROLLED, {
        scroll: scroll
    });
}
function $6c18613b3e53070e$var$resizeHandler() {
    var ias = this;
    var lastScroll = ias._lastScroll || $6c18613b3e53070e$var$defaultLastScroll;
    var scroll = ias._lastScroll = $6c18613b3e53070e$var$calculateScroll(ias.scrollContainer, lastScroll);
    this.emitter.emit($6c18613b3e53070e$var$RESIZED, {
        scroll: scroll
    });
}
function $6c18613b3e53070e$var$nextHandler(pageIndex) {
    var ias = this;
    var lastResponse = ias._lastResponse || document.body;
    var nextEl = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(ias.options.next, lastResponse)[0];
    if (!nextEl) {
        $6c18613b3e53070e$var$Assert.warn($6c18613b3e53070e$var$Assert.singleElement, ias.options.next, 'options.next');
        return;
    }
    var nextUrl = nextEl.href;
    return ias.load(nextUrl).then(function(data) {
        lastResponse = ias._lastResponse = data.xhr.response;
        var nextEl = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(ias.options.next, lastResponse)[0];
        return ias.append(data.items).then(function() {
            return !!nextEl;
        }).then(function(hasNextEl) {
            // only warn for first page, because at some point it's expected that there is no next element
            if (!hasNextEl && pageIndex <= 1 && console && console.warn) console.warn("Element \"" + ias.options.next + "\" not found for \"options.next\" on \"" + data.url + "\"");
            return hasNextEl;
        });
    });
}
function $6c18613b3e53070e$var$prevHandler(pageIndex) {
    var ias = this;
    var prevEl = ias._prevEl || (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(ias.options.prev, document.body)[0];
    if (ias.options.prev === undefined) return;
    if (!prevEl) {
        $6c18613b3e53070e$var$Assert.warn($6c18613b3e53070e$var$Assert.singleElement, ias.options.prev, 'options.prev');
        return;
    }
    var prevUrl = prevEl.href;
    return ias.load(prevUrl).then(function(data) {
        var prevEl = ias._prevEl = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(ias.options.prev, data.xhr.response)[0];
        return ias.prepend(data.items).then(function() {
            return !!prevEl;
        }) // TODO: evaluate if this makes sense
        ;
    });
}
var $6c18613b3e53070e$var$defaults$2 = {
    element: undefined,
    hide: false
};
function $6c18613b3e53070e$var$expand$3(options) {
    if (typeof options === 'string' || typeof options === 'object' && options.nodeType === Node.ELEMENT_NODE) options = {
        element: options,
        hide: true
    };
    else if (typeof options === 'boolean') options = {
        element: undefined,
        hide: options
    };
    return options;
}
var $6c18613b3e53070e$var$Pagination = function Pagination(ias, options) {
    this.options = (0, (/*@__PURE__*/$parcel$interopDefault($16d474a0815e976d$exports)))({}, $6c18613b3e53070e$var$defaults$2, $6c18613b3e53070e$var$expand$3(options));
    this.originalDisplayStyles = new WeakMap();
    if (!this.options.hide) return;
    $6c18613b3e53070e$var$Assert.warn($6c18613b3e53070e$var$Assert.anyElement, this.options.element, 'pagination.element');
    ias.on($6c18613b3e53070e$var$BINDED, this.hide.bind(this));
    ias.on($6c18613b3e53070e$var$UNBINDED, this.restore.bind(this));
};
$6c18613b3e53070e$var$Pagination.prototype.hide = function hide() {
    var this$1$1 = this;
    var els = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(this.options.element);
    els.forEach(function(el) {
        this$1$1.originalDisplayStyles.set(el, window.getComputedStyle(el).display);
        el.style.display = 'none';
    });
};
$6c18613b3e53070e$var$Pagination.prototype.restore = function restore() {
    var this$1$1 = this;
    var els = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(this.options.element);
    els.forEach(function(el) {
        el.style.display = this$1$1.originalDisplayStyles.get(el) || 'block';
    });
};
var $6c18613b3e53070e$var$defaults$1 = {
    element: undefined,
    delay: 600,
    show: function(element) {
        element.style.opacity = '1';
    },
    hide: function(element) {
        element.style.opacity = '0';
    }
};
function $6c18613b3e53070e$var$expand$2(options) {
    if (typeof options === 'string' || typeof options === 'object' && options.nodeType === Node.ELEMENT_NODE) options = {
        element: options
    };
    return options;
}
var $6c18613b3e53070e$var$Spinner = function Spinner(ias, options) {
    // no spinner wanted
    if (options === false) return;
    this.ias = ias;
    this.options = (0, (/*@__PURE__*/$parcel$interopDefault($16d474a0815e976d$exports)))({}, $6c18613b3e53070e$var$defaults$1, $6c18613b3e53070e$var$expand$2(options));
    if (this.options.element !== undefined) $6c18613b3e53070e$var$Assert.singleElement(this.options.element, 'spinner.element');
    this.element = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(this.options.element)[0]; // @todo should we really cache this?
    this.hideFn = this.options.hide;
    this.showFn = this.options.show;
    ias.on($6c18613b3e53070e$var$BINDED, this.bind.bind(this));
    ias.on($6c18613b3e53070e$var$BINDED, this.hide.bind(this));
};
$6c18613b3e53070e$var$Spinner.prototype.bind = function bind() {
    var startTime, endTime, diff, delay, self = this, ias = this.ias;
    ias.on($6c18613b3e53070e$var$NEXT, function() {
        startTime = +new Date();
        self.show();
    });
    ias.on($6c18613b3e53070e$var$LAST, function() {
        self.hide();
    });
    // setup delay
    ias.on($6c18613b3e53070e$var$APPEND, function(event) {
        endTime = +new Date();
        diff = endTime - startTime;
        delay = Math.max(0, self.options.delay - diff);
        var _appendFn = event.appendFn.bind({});
        event.appendFn = function(items, parent, last) {
            return new Promise(function(resolve) {
                setTimeout(function() {
                    self.hide().then(function() {
                        _appendFn(items, parent, last);
                        resolve();
                    });
                }, delay);
            });
        };
    });
};
$6c18613b3e53070e$var$Spinner.prototype.show = function show() {
    return Promise.resolve(this.showFn(this.element));
};
$6c18613b3e53070e$var$Spinner.prototype.hide = function hide() {
    return Promise.resolve(this.hideFn(this.element));
};
/* eslint no-console: "off" */ var $6c18613b3e53070e$var$defaultLogger = {
    hit: function() {
        console.log("Hit scroll threshold");
    },
    top: function() {
        console.log("Hit top scroll threshold");
    },
    binded: function() {
        console.log("Binded event handlers");
    },
    unbinded: function() {
        console.log("Unbinded event handlers");
    },
    // scrolled: (event) => {
    //   console.log('Scrolled');
    // },
    // resized: (event) => {
    //   console.log('Resized');
    // },
    next: function(event) {
        console.log("Next page triggered [pageIndex=" + event.pageIndex + "]");
    },
    nexted: function(event) {
        console.log("Next page completed [pageIndex=" + event.pageIndex + "]");
    },
    prev: function(event) {
        console.log("Previous page triggered [pageIndex=" + event.pageIndex + "]");
    },
    preved: function(event) {
        console.log("Previous page completed [pageIndex=" + event.pageIndex + "]");
    },
    load: function(event) {
        console.log("Start loading " + event.url);
    },
    loaded: function() {
        console.log("Finished loading");
    },
    append: function() {
        console.log("Start appending items");
    },
    appended: function(event) {
        console.log("Finished appending " + event.items.length + " item(s)");
    },
    prepend: function() {
        console.log("Start prepending items");
    },
    prepended: function(event) {
        console.log("Finished prepending " + event.items.length + " item(s)");
    },
    last: function() {
        console.log("No more pages left to load");
    },
    first: function() {
        console.log("Reached first page");
    },
    page: function(event) {
        console.log("Page changed [pageIndex=" + event.pageIndex + "]");
    },
    prefill: function(event) {
        console.log("Start prefilling");
    },
    prefilled: function(event) {
        console.log("Finished prefilling");
    }
};
function $6c18613b3e53070e$var$expand$1(options) {
    if (options === true) options = $6c18613b3e53070e$var$defaultLogger;
    return options;
}
var $6c18613b3e53070e$var$Logger = function Logger(ias, options) {
    // no logger wanted
    if (options === false) return;
    var logger = $6c18613b3e53070e$var$expand$1(options);
    Object.keys(logger).forEach(function(key) {
        ias.on(key, logger[key]);
    });
};
function $6c18613b3e53070e$var$getPageBreak(pageBreaks, scrollTop, scrollContainer) {
    var rootRect = $6c18613b3e53070e$var$getRootRect(scrollContainer);
    var scrollBottom = scrollTop + rootRect.height;
    for(var b = pageBreaks.length - 1; b >= 0; b--){
        var bottom = pageBreaks[b].sentinel.getBoundingClientRect().bottom + scrollTop;
        if (scrollBottom > bottom) {
            var x = Math.min(b + 1, pageBreaks.length - 1);
            return pageBreaks[x];
        }
    }
    return pageBreaks[0];
}
var $6c18613b3e53070e$var$Paging = function Paging(ias) {
    this.ias = ias;
    this.pageBreaks = [];
    this.currentPageIndex = ias.pageIndex;
    this.currentScrollTop = 0;
    ias.on($6c18613b3e53070e$var$BINDED, this.binded.bind(this));
    ias.on($6c18613b3e53070e$var$NEXT, this.next.bind(this));
    ias.on($6c18613b3e53070e$var$PREV, this.prev.bind(this));
    ias.on($6c18613b3e53070e$var$SCROLLED, this.scrolled.bind(this));
    ias.on($6c18613b3e53070e$var$RESIZED, this.scrolled.bind(this));
};
$6c18613b3e53070e$var$Paging.prototype.binded = function binded() {
    var sentinel = this.ias.sentinel();
    if (!sentinel) return;
    this.pageBreaks.push({
        pageIndex: this.currentPageIndex,
        url: document.location.toString(),
        title: document.title,
        sentinel: this.ias.sentinel()
    });
};
$6c18613b3e53070e$var$Paging.prototype.next = function next() {
    var this$1$1 = this;
    var url = document.location.toString();
    var title = document.title;
    var loaded = function(event) {
        url = event.url;
        if (event.xhr.response) title = event.xhr.response.title;
    };
    this.ias.once($6c18613b3e53070e$var$LOADED, loaded);
    this.ias.once($6c18613b3e53070e$var$NEXTED, function(event) {
        this$1$1.pageBreaks.push({
            pageIndex: event.pageIndex,
            url: url,
            title: title,
            sentinel: this$1$1.ias.sentinel()
        });
        this$1$1.update();
        this$1$1.ias.off($6c18613b3e53070e$var$LOADED, loaded);
    });
};
$6c18613b3e53070e$var$Paging.prototype.prev = function prev() {
    var this$1$1 = this;
    var url = document.location.toString();
    var title = document.title;
    var loaded = function(event) {
        url = event.url;
        if (event.xhr.response) title = event.xhr.response.title;
    };
    this.ias.once($6c18613b3e53070e$var$LOADED, loaded);
    this.ias.once($6c18613b3e53070e$var$PREVED, function(event) {
        this$1$1.pageBreaks.unshift({
            pageIndex: event.pageIndex,
            url: url,
            title: title,
            sentinel: this$1$1.ias.first()
        });
        this$1$1.update();
        this$1$1.ias.off($6c18613b3e53070e$var$LOADED, loaded);
    });
};
$6c18613b3e53070e$var$Paging.prototype.scrolled = function scrolled(event) {
    this.update(event.scroll.y);
};
$6c18613b3e53070e$var$Paging.prototype.update = function update(scrollTop) {
    this.currentScrollTop = scrollTop || this.currentScrollTop;
    var pageBreak = $6c18613b3e53070e$var$getPageBreak(this.pageBreaks, this.currentScrollTop, this.ias.scrollContainer);
    if (pageBreak && pageBreak.pageIndex !== this.currentPageIndex) {
        this.ias.emitter.emit($6c18613b3e53070e$var$PAGE, pageBreak);
        this.currentPageIndex = pageBreak.pageIndex;
    }
};
var $6c18613b3e53070e$var$defaults = {
    element: undefined,
    when: function(pageIndex) {
        return true;
    },
    show: function(element) {
        element.style.opacity = '1';
    },
    hide: function(element) {
        element.style.opacity = '0';
    }
};
function $6c18613b3e53070e$var$expand(options) {
    if (typeof options === 'string' || typeof options === 'function' || typeof options === 'object' && options.nodeType === Node.ELEMENT_NODE) options = {
        element: options
    };
    if (typeof options.element === 'function') options.element = options.element();
    // expand array to a function, e.g.:
    // [0, 1, 2] -> function(pageIndex) { /* return true when pageIndex in [0, 1, 2] */ }
    if (options.when && Array.isArray(options.when)) {
        var when = options.when;
        options.when = function(pageIndex) {
            return when.indexOf(pageIndex) !== -1;
        };
    }
    return options;
}
var $6c18613b3e53070e$var$Trigger = function Trigger(ias, options) {
    var this$1$1 = this;
    // no trigger wanted
    if (options === false) return;
    this.ias = ias;
    this.options = (0, (/*@__PURE__*/$parcel$interopDefault($16d474a0815e976d$exports)))({}, $6c18613b3e53070e$var$defaults, $6c18613b3e53070e$var$expand(options));
    if (this.options.element !== undefined) $6c18613b3e53070e$var$Assert.singleElement(this.options.element, 'trigger.element');
    this.element = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(this.options.element)[0]; // @todo should we really cache this?
    this.hideFn = this.options.hide;
    this.showFn = this.options.show;
    this.voter = this.options.when;
    this.showing = undefined;
    this.enabled = undefined;
    ias.on($6c18613b3e53070e$var$BINDED, this.bind.bind(this));
    ias.on($6c18613b3e53070e$var$UNBINDED, this.unbind.bind(this));
    ias.on($6c18613b3e53070e$var$HIT, this.hit.bind(this));
    ias.on($6c18613b3e53070e$var$NEXT, function(e) {
        return this$1$1.ias.once($6c18613b3e53070e$var$APPENDED, function() {
            return this$1$1.update(e.pageIndex);
        });
    });
};
$6c18613b3e53070e$var$Trigger.prototype.bind = function bind() {
    this.hide();
    this.update(this.ias.pageIndex);
    this.element.addEventListener('click', this.clickHandler.bind(this));
};
$6c18613b3e53070e$var$Trigger.prototype.unbind = function unbind() {
    this.element.removeEventListener('click', this.clickHandler.bind(this));
};
$6c18613b3e53070e$var$Trigger.prototype.clickHandler = function clickHandler() {
    this.hide().then(this.ias.next.bind(this.ias));
};
$6c18613b3e53070e$var$Trigger.prototype.update = function update(pageIndex) {
    this.enabled = this.voter(pageIndex);
    if (this.enabled) this.ias.disableLoadOnScroll();
    else this.ias.enableLoadOnScroll();
};
$6c18613b3e53070e$var$Trigger.prototype.hit = function hit() {
    if (!this.enabled) return;
    this.show();
};
$6c18613b3e53070e$var$Trigger.prototype.show = function show() {
    if (this.showing) return;
    this.showing = true;
    return Promise.resolve(this.showFn(this.element));
};
$6c18613b3e53070e$var$Trigger.prototype.hide = function hide() {
    if (!this.showing && this.showing !== undefined) return;
    this.showing = false;
    return Promise.resolve(this.hideFn(this.element));
};
function $6c18613b3e53070e$var$appendFn(items, parent, last) {
    var sibling = last ? last.nextSibling : null;
    var insert = document.createDocumentFragment();
    items.forEach(function(item) {
        insert.appendChild(item);
    });
    parent.insertBefore(insert, sibling);
}
function $6c18613b3e53070e$var$prependFn(items, parent, first) {
    var insert = document.createDocumentFragment();
    items.forEach(function(item) {
        insert.appendChild(item);
    });
    parent.insertBefore(insert, first);
}
/* eslint no-console: "off" */ var $6c18613b3e53070e$var$NativeResizeObserver = window.ResizeObserver;
var $6c18613b3e53070e$var$EventListenerResizeObserver = function EventListenerResizeObserver(el, listener) {
    this.el = el;
    this.listener = listener;
};
$6c18613b3e53070e$var$EventListenerResizeObserver.prototype.observe = function observe() {
    this.el.addEventListener('resize', this.listener);
};
$6c18613b3e53070e$var$EventListenerResizeObserver.prototype.unobserve = function unobserve() {
    this.el.removeEventListener('resize', this.listener);
};
var $6c18613b3e53070e$var$NativeWrapperResizeObserver = function NativeWrapperResizeObserver(el, listener) {
    this.el = el;
    this.listener = listener;
    this.ro = new $6c18613b3e53070e$var$NativeResizeObserver(this.listener);
};
$6c18613b3e53070e$var$NativeWrapperResizeObserver.prototype.observe = function observe() {
    this.ro.observe(this.el);
};
$6c18613b3e53070e$var$NativeWrapperResizeObserver.prototype.unobserve = function unobserve() {
    this.ro.unobserve();
};
var $6c18613b3e53070e$var$PollingResizeObserver = function PollingResizeObserver(el, listener) {
    this.el = el;
    this.listener = listener;
    this.interval = null;
    this.lastHeight = null;
};
$6c18613b3e53070e$var$PollingResizeObserver.prototype.pollHeight = function pollHeight() {
    var height = Math.trunc($6c18613b3e53070e$var$getRootRect(this.el).height);
    if (this.lastHeight !== null && this.lastHeight !== height) this.listener();
    this.lastHeight = height;
};
$6c18613b3e53070e$var$PollingResizeObserver.prototype.observe = function observe() {
    this.interval = setInterval(this.pollHeight.bind(this), 200);
};
$6c18613b3e53070e$var$PollingResizeObserver.prototype.unobserve = function unobserve() {
    clearInterval(this.interval);
};
function $6c18613b3e53070e$var$ResizeObserverFactory(ias, el) {
    var listener = (0, (/*@__PURE__*/$parcel$interopDefault($ac43bb23aa0a60e2$exports)))($6c18613b3e53070e$var$resizeHandler, 200).bind(ias);
    if (el === window) return new $6c18613b3e53070e$var$EventListenerResizeObserver(el, listener);
    if ($6c18613b3e53070e$var$NativeResizeObserver) return new $6c18613b3e53070e$var$NativeWrapperResizeObserver(el, listener);
    if (console && console.warn) console.warn('ResizeObserver not supported. Falling back on polling.');
    return new $6c18613b3e53070e$var$PollingResizeObserver(el, listener);
}
var $6c18613b3e53070e$var$Prefill = function Prefill(ias, options) {
    this.ias = ias;
    this.enabled = options;
};
$6c18613b3e53070e$var$Prefill.prototype.prefill = function prefill() {
    var this$1$1 = this;
    if (!this.enabled) return;
    this.ias.emitter.emit($6c18613b3e53070e$var$events.PREFILL);
    return Promise.all([
        this._prefillNext(),
        this._prefillPrev()
    ]).then(function() {
        this$1$1.ias.emitter.emit($6c18613b3e53070e$var$events.PREFILLED);
        // @todo reevaluate if we should actually call `measure` here.
        this$1$1.ias.measure();
    });
};
$6c18613b3e53070e$var$Prefill.prototype._prefillNext = function _prefillNext() {
    var this$1$1 = this;
    var distance = this.ias.distance();
    if (distance > 0) return;
    return this.ias.next().then(function(hasNextUrl) {
        if (!hasNextUrl) return;
        var distance = this$1$1.ias.distance();
        if (distance < 0) return this$1$1._prefillNext();
    });
};
$6c18613b3e53070e$var$Prefill.prototype._prefillPrev = function _prefillPrev() {
    if (!this.ias.options.prev) return;
    return this.ias.prev();
};
var $6c18613b3e53070e$export$2e2bcd8739ae039 = function InfiniteAjaxScroll(container, options) {
    var this$1$1 = this;
    if (options === void 0) options = {};
    $6c18613b3e53070e$var$Assert.singleElement(container, 'container');
    this.container = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(container)[0];
    this.options = (0, (/*@__PURE__*/$parcel$interopDefault($16d474a0815e976d$exports)))({}, $6c18613b3e53070e$var$defaults$3, options);
    this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($bb3d51bfa22856f3$exports)))();
    this.options.loadOnScroll ? this.enableLoadOnScroll() : this.disableLoadOnScroll();
    this.negativeMargin = Math.abs(this.options.negativeMargin);
    this.scrollContainer = this.options.scrollContainer;
    if (this.options.scrollContainer !== window) {
        $6c18613b3e53070e$var$Assert.singleElement(this.options.scrollContainer, 'options.scrollContainer');
        this.scrollContainer = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(this.options.scrollContainer)[0];
    }
    this.nextHandler = $6c18613b3e53070e$var$nextHandler;
    this.prevHandler = $6c18613b3e53070e$var$prevHandler;
    if (this.options.next === false) this.nextHandler = function() {};
    else if (typeof this.options.next === 'function') this.nextHandler = this.options.next;
    if (this.options.prev === false) this.prevHandler = function() {};
    else if (typeof this.options.prev === 'function') this.prevHandler = this.options.prev;
    this.resizeObserver = $6c18613b3e53070e$var$ResizeObserverFactory(this, this.scrollContainer);
    this._scrollListener = (0, (/*@__PURE__*/$parcel$interopDefault($ac43bb23aa0a60e2$exports)))($6c18613b3e53070e$var$scrollHandler, 200).bind(this);
    this.ready = false;
    this.bindOnReady = true;
    this.binded = false;
    this.paused = false;
    this.pageIndexPrev = 0;
    this.pageIndex = this.pageIndexNext = this.sentinel() ? 0 : -1;
    this.on($6c18613b3e53070e$var$HIT, function() {
        if (!this$1$1.loadOnScroll) return;
        this$1$1.next();
    });
    this.on($6c18613b3e53070e$var$TOP, function() {
        if (!this$1$1.loadOnScroll) return;
        this$1$1.prev();
    });
    this.on($6c18613b3e53070e$var$SCROLLED, this.measure);
    this.on($6c18613b3e53070e$var$RESIZED, this.measure);
    // initialize extensions
    this.pagination = new $6c18613b3e53070e$var$Pagination(this, this.options.pagination);
    this.spinner = new $6c18613b3e53070e$var$Spinner(this, this.options.spinner);
    this.logger = new $6c18613b3e53070e$var$Logger(this, this.options.logger);
    this.paging = new $6c18613b3e53070e$var$Paging(this);
    this.trigger = new $6c18613b3e53070e$var$Trigger(this, this.options.trigger);
    this.prefill = new $6c18613b3e53070e$var$Prefill(this, this.options.prefill);
    // prefill/measure after all plugins are done binding
    this.on($6c18613b3e53070e$var$BINDED, this.prefill.prefill.bind(this.prefill));
    this.hitFirst = this.hitLast = false;
    this.on($6c18613b3e53070e$var$LAST, function() {
        return this$1$1.hitLast = true;
    });
    this.on($6c18613b3e53070e$var$FIRST, function() {
        return this$1$1.hitFirst = true;
    });
    var ready = function() {
        if (this$1$1.ready) return;
        this$1$1.ready = true;
        this$1$1.emitter.emit($6c18613b3e53070e$var$READY);
        if (this$1$1.bindOnReady && this$1$1.options.bind) this$1$1.bind();
    };
    if (document.readyState === "complete" || document.readyState === "interactive") setTimeout(ready, 1);
    else window.addEventListener('DOMContentLoaded', ready);
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.bind = function bind() {
    if (this.binded) return;
    // If we manually call bind before the dom is ready, we assume that we want
    // to take control over the bind flow.
    if (!this.ready) this.bindOnReady = false;
    this.scrollContainer.addEventListener('scroll', this._scrollListener);
    this.resizeObserver.observe();
    this.binded = true;
    this.emitter.emit($6c18613b3e53070e$var$BINDED);
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.unbind = function unbind() {
    if (!this.binded) {
        if (!this.ready) this.once($6c18613b3e53070e$var$BINDED, this.unbind);
        return;
    }
    this.resizeObserver.unobserve();
    this.scrollContainer.removeEventListener('scroll', this._scrollListener);
    this.binded = false;
    this.emitter.emit($6c18613b3e53070e$var$UNBINDED);
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.next = function next() {
    var this$1$1 = this;
    if (this.hitLast) return;
    if (!this.binded) {
        if (!this.ready) return this.once($6c18613b3e53070e$var$BINDED, this.next);
        return;
    }
    this.pause();
    var pageIndex = this.pageIndexNext + 1;
    this.emitter.emit($6c18613b3e53070e$var$NEXT, {
        pageIndex: this.pageIndexNext + 1
    });
    return Promise.resolve(this.nextHandler(pageIndex)).then(function(hasNextUrl) {
        this$1$1.pageIndexNext = pageIndex;
        if (!hasNextUrl) this$1$1.emitter.emit($6c18613b3e53070e$var$LAST);
        this$1$1.resume();
        return hasNextUrl;
    }).then(function(hasNextUrl) {
        this$1$1.emitter.emit($6c18613b3e53070e$var$NEXTED, {
            pageIndex: this$1$1.pageIndexNext
        });
        return hasNextUrl;
    });
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.prev = function prev() {
    var this$1$1 = this;
    if (!this.binded || this.hitFirst) return;
    this.pause();
    var pageIndex = this.pageIndexPrev - 1;
    this.emitter.emit($6c18613b3e53070e$var$PREV, {
        pageIndex: this.pageIndexPrev - 1
    });
    return Promise.resolve(this.prevHandler(pageIndex)).then(function(hasPrevUrl) {
        this$1$1.pageIndexPrev = pageIndex;
        this$1$1.resume();
        if (!hasPrevUrl) this$1$1.emitter.emit($6c18613b3e53070e$var$FIRST);
        return hasPrevUrl;
    }).then(function(hasPrevUrl) {
        this$1$1.emitter.emit($6c18613b3e53070e$var$PREVED, {
            pageIndex: this$1$1.pageIndexPrev
        });
        return hasPrevUrl;
    });
};
/**
 * @param {string} url
 * @returns {Promise} returns LOADED event on success
 */ $6c18613b3e53070e$export$2e2bcd8739ae039.prototype.load = function load(url) {
    var ias = this;
    return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
        var loadEvent = {
            url: url,
            xhr: xhr,
            method: 'GET',
            body: null,
            nocache: false,
            responseType: ias.options.responseType,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // event properties are mutable
        ias.emitter.emit($6c18613b3e53070e$var$LOAD, loadEvent);
        var finalUrl = loadEvent.url;
        var method = loadEvent.method;
        var responseType = loadEvent.responseType;
        var headers = loadEvent.headers;
        var body = loadEvent.body;
        if (!loadEvent.nocache) // @see https://developer.mozilla.org/nl/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
        finalUrl = finalUrl + (/\?/.test(finalUrl) ? "&" : "?") + new Date().getTime();
        xhr.onreadystatechange = function() {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;
            if (xhr.status === 0) ;
            else if (xhr.status === 200) {
                var items = xhr.response;
                if (responseType === 'document') items = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(ias.options.item, xhr.response);
                // we don't use a shared loadedEvent variable here, because these values should be immutable
                ias.emitter.emit($6c18613b3e53070e$var$LOADED, {
                    items: items,
                    url: finalUrl,
                    xhr: xhr
                });
                resolve({
                    items: items,
                    url: finalUrl,
                    xhr: xhr
                });
            } else {
                ias.emitter.emit($6c18613b3e53070e$var$ERROR, {
                    url: finalUrl,
                    method: method,
                    xhr: xhr
                });
                reject(xhr);
            }
        };
        xhr.onerror = function() {
            ias.emitter.emit($6c18613b3e53070e$var$ERROR, {
                url: finalUrl,
                method: method,
                xhr: xhr
            });
            reject(xhr);
        };
        xhr.open(method, finalUrl, true);
        xhr.responseType = responseType;
        for(var header in headers)xhr.setRequestHeader(header, headers[header]);
        xhr.send(body);
    });
};
/**
 * @param {array<Element>} items
 * @param {Element|null} parent
 */ $6c18613b3e53070e$export$2e2bcd8739ae039.prototype.append = function append(items, parent) {
    var ias = this;
    parent = parent || ias.container;
    var event = {
        items: items,
        parent: parent,
        appendFn: $6c18613b3e53070e$var$appendFn
    };
    ias.emitter.emit($6c18613b3e53070e$var$APPEND, event);
    var executor = function(resolve) {
        window.requestAnimationFrame(function() {
            Promise.resolve(event.appendFn(event.items, event.parent, ias.sentinel())).then(function() {
                resolve({
                    items: items,
                    parent: parent
                });
            });
        });
    };
    return new Promise(executor).then(function(event) {
        ias.emitter.emit($6c18613b3e53070e$var$APPENDED, event);
    });
};
/**
 * @param {array<Element>} items
 * @param {Element|null} parent
 */ $6c18613b3e53070e$export$2e2bcd8739ae039.prototype.prepend = function prepend(items, parent) {
    var this$1$1 = this;
    var ias = this;
    parent = parent || ias.container;
    var event = {
        items: items,
        parent: parent,
        prependFn: $6c18613b3e53070e$var$prependFn
    };
    ias.emitter.emit($6c18613b3e53070e$var$PREPEND, event);
    var executor = function(resolve) {
        window.requestAnimationFrame(function() {
            var first = ias.first();
            var scrollPositionStart = $6c18613b3e53070e$var$getScrollPosition(this$1$1.scrollContainer);
            var topStart = first.getBoundingClientRect().top + scrollPositionStart.y;
            Promise.resolve(event.prependFn(event.items, event.parent, ias.first())).then(function() {
                var scrollPositionEnd = $6c18613b3e53070e$var$getScrollPosition(this$1$1.scrollContainer);
                var topEnd = first.getBoundingClientRect().top + scrollPositionEnd.y;
                var deltaY = topEnd - topStart;
                this$1$1.scrollContainer.scrollTo(scrollPositionEnd.x, deltaY);
            }).then(function() {
                resolve({
                    items: items,
                    parent: parent
                });
            });
        });
    };
    return new Promise(executor).then(function(event) {
        ias.emitter.emit($6c18613b3e53070e$var$PREPENDED, event);
    });
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.sentinel = function sentinel() {
    var items = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(this.options.item, this.container);
    if (!items.length) return null;
    return items[items.length - 1];
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.first = function first() {
    var items = (0, $0762156f26e68f1c$export$2e2bcd8739ae039)(this.options.item, this.container);
    if (!items.length) return null;
    return items[0];
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.pause = function pause() {
    this.paused = true;
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.resume = function resume() {
    this.paused = false;
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.enableLoadOnScroll = function enableLoadOnScroll() {
    this.loadOnScroll = true;
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.disableLoadOnScroll = function disableLoadOnScroll() {
    this.loadOnScroll = false;
};
/**
 * @deprecated replaced by distanceBottom
 */ $6c18613b3e53070e$export$2e2bcd8739ae039.prototype.distance = function distance(rootRect, sentinel) {
    return this.distanceBottom(rootRect, sentinel);
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.distanceBottom = function distanceBottom(rootRect, sentinel) {
    var _rootRect = rootRect || $6c18613b3e53070e$var$getRootRect(this.scrollContainer);
    var _sentinel = sentinel || this.sentinel();
    var scrollPosition = $6c18613b3e53070e$var$getScrollPosition(this.scrollContainer);
    var distance = $6c18613b3e53070e$var$getDistanceToFold(_sentinel, scrollPosition, _rootRect);
    // apply negative margin
    distance -= this.negativeMargin;
    return distance;
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.distanceTop = function distanceTop() {
    var scrollPosition = $6c18613b3e53070e$var$getScrollPosition(this.scrollContainer);
    return scrollPosition.y - this.negativeMargin;
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.measure = function measure() {
    if (this.paused || this.hitFirst && this.hitLast) return;
    var rootRect = $6c18613b3e53070e$var$getRootRect(this.scrollContainer);
    // When the scroll container has no height, this could indicate that
    // the element is not visible (display = none). Without a height
    // we cannot calculate the distance to fold. On the other hand we don't
    // have to, because it's not visible anyway. Our resize observer will
    // monitor the height, once it's greater than 0 everything will resume as normal.
    if (rootRect.height === 0) // @todo DX: show warning in console that this is happening
    return;
    if (!this.hitFirst) {
        var distanceTop = this.distanceTop();
        if (distanceTop <= 0) this.emitter.emit($6c18613b3e53070e$var$TOP, {
            distance: distanceTop
        });
    }
    if (!this.hitLast) {
        var distanceBottom = this.distanceBottom(rootRect, this.sentinel());
        if (distanceBottom <= 0) this.emitter.emit($6c18613b3e53070e$var$HIT, {
            distance: distanceBottom
        });
    }
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.on = function on(event, callback) {
    this.emitter.on(event, callback, this);
    if (event === $6c18613b3e53070e$var$BINDED && this.binded) callback.bind(this)();
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.off = function off(event, callback) {
    this.emitter.off(event, callback, this);
};
$6c18613b3e53070e$export$2e2bcd8739ae039.prototype.once = function once(event, callback) {
    var this$1$1 = this;
    return new Promise(function(resolve) {
        this$1$1.emitter.once(event, function() {
            Promise.resolve(callback.apply(this, arguments)).then(resolve);
        }, this$1$1);
        if (event === $6c18613b3e53070e$var$BINDED && this$1$1.binded) {
            callback.bind(this$1$1)();
            resolve();
        }
    });
};


let $8822b06a5c3d7942$var$nextHandler = function(pageIndex) {
    let frag = document.createDocumentFragment();
    let limit = 72;
    let offset = pageIndex * limit;
    for(let i = offset, len = offset + limit; i < len; i++){
        let block = frag.appendChild(document.createElement('div'));
        block.id = 'block' + (i + 1);
        block.classList.add('blocks__block');
        block.innerHTML = i + 1;
    }
    return this.append(Array.from(frag.childNodes))// indicate that there is a next page to load
    .then(()=>true);
};
window.ias = new (0, $6c18613b3e53070e$export$2e2bcd8739ae039)('.blocks', {
    item: '.blocks__block',
    next: $8822b06a5c3d7942$var$nextHandler,
    spinner: '.loader'
});



"use strict";


function $dad545c909cfec2d$var$loadScript(url) {
    return new Promise((resolve)=>{
        let head = document.getElementsByTagName('head')[0];
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.onload = ()=>{
            resolve();
        };
        // Fire the loading
        head.appendChild(script);
    });
}
const $dad545c909cfec2d$var$css = '.metabar {\n  position: fixed;\n  width: 100%;\n  top: 0;\n  background-color: #fff;\n  opacity: .95;\n  z-index: 1;\n}\n\n.metabar .metabar-inner {\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 0 20px;\n  text-align: center;\n  height: 65px;\n\n  display: flex;\n  flex-flow: row;\n  align-items: center;\n}\n\n.metabar .metabar-inner > * {\n  flex: 33%;\n}\n\n.metabar .logo {\n  display: inline-block;\n}\n\n.metabar .logo img {\n  height: 30px;\n}\n\n.metabar .metabar__link {\n  color: #999;\n  text-decoration: none;\n}\n\n.metabar .metabar__link:hover {\n  color: #f63840;\n}\n\n.metabar .metabar__block--left {\n  text-align: left;\n  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva, Arial, sans-serif;\n  color: #999;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.5em;\n}\n\n.metabar .metabar__block--right {\n  text-align: right;\n}\n\n.metabar .btn {\n  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva, Arial, sans-serif;\n  font-size: 14px;\n  font-weight: normal;\n\n  color: #FA612E;\n  display: inline-block;\n  vertical-align: middle;\n\n  height: 32px;\n  line-height: 30px;\n  padding: 0 16px;\n  border: 1px solid #FA612E;\n  border-radius: 4px;\n\n  text-decoration: none;\n}\n\n@media only screen and (max-width: 580px) {\n  .codesandbox {\n    display: inline-block;\n    height: 21px;\n    width: 18px;\n    overflow: hidden;\n    text-indent: -999px;\n    margin-top: -1px;\n    background: transparent url("./code-sandbox-logo.png") no-repeat;\n    background-size: 18px 21px;\n    vertical-align: middle;\n  }\n}\n';
const $dad545c909cfec2d$var$meta = JSON.parse('{"codesandbox_url":"https://codesandbox.io/s/github/webcreate/infinite-ajax-scroll/tree/master/examples/blocks"}\n');
let $dad545c909cfec2d$var$metabar = `<div class="metabar">
        <div class="metabar-inner">
            <div class="metabar__block metabar__block--left"><a href="/examples/" class="metabar__link">&leftarrow; More examples</a></div>
            <div>
                <a href="https://infiniteajaxscroll.com" title="Infinite Ajax Scroll" class="logo"><img src="${(0, {})}"></a>
            </div>
            <div class="metabar__block metabar__block--right"><a href="${$dad545c909cfec2d$var$meta.codesandbox_url}" class="btn" target="_blank">Edit on <span class="codesandbox" title="CodeSandbox">CodeSandbox</span></a></div>
        </div>
    </div>
    <style>${$dad545c909cfec2d$var$css}</style>`;
// let style = parseInt(window.getComputedStyle(document.body).paddingTop);
// document.body.style.paddingTop = (style + 65) + 'px';
document.body.insertAdjacentHTML('afterbegin', $dad545c909cfec2d$var$metabar);
// google analytics
$dad545c909cfec2d$var$loadScript('https://www.googletagmanager.com/gtag/js?id=UA-18000252-3').then(()=>{
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'UA-18000252-3');
});
// drift
// !function() {
//   var t;
//   if (t = window.driftt = window.drift = window.driftt || [], !t.init) return t.invoked ? void (window.console && console.error && console.error("Drift snippet included twice.")) : (t.invoked = !0,
//       t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ],
//       t.factory = function(e) {
//         return function() {
//           var n;
//           return n = Array.prototype.slice.call(arguments), n.unshift(e), t.push(n), t;
//         };
//       }, t.methods.forEach(function(e) {
//     t[e] = t.factory(e);
//   }), t.load = function(t) {
//     var e, n, o, i;
//     e = 3e5, i = Math.ceil(new Date() / e) * e, o = document.createElement("script"),
//         o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + i + "/" + t + ".js",
//         n = document.getElementsByTagName("script")[0], n.parentNode.insertBefore(o, n);
//   });
// }();
// drift.SNIPPET_VERSION = '0.3.1';
// drift.load('6xfngbrkf5ky');
// hotjar
(function(h, o, t, j, a, r) {
    h.hj = h.hj || function() {
        (h.hj.q = h.hj.q || []).push(arguments);
    };
    h._hjSettings = {
        hjid: 1472346,
        hjsv: 6
    };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
})(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');


//# sourceMappingURL=clone.5747dec1.js.map
